import { queryPremiumRateForMEBandMEAPlus as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForMEAPlus as calculateRiderPremium } from 'core/service/rider/premium-calculation'
import { queryTaxRateForMEAPlus as queryTaxRate } from 'core/service/rider/query-tax-rate'

export default {
  calculateRiderPremium,
  queryPremiumRate,
  queryTaxRate,
}
